import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectSavingsStaff } from "../Model/ProposalProjectSavingsStaff";

export async function deleteProposalProjectSavingsStaff(id) {
    let response = await getAPIResponse("/v1/proposal-project-staff/"+id, {} , "DELETE");
    if (response === null) {
        return null;
    }
    let proposalProjectSavingsStaff = ProposalProjectSavingsStaff.createFromResponseData(response);
    return proposalProjectSavingsStaff;
}